// AssignmentDetailSheet.jsx — 배정 상세 창 (2026-10-06, 배정 한 건에 대한 모든 동작을 한곳에)
//   [담당 마케터 바꾸기] [배정 끝내기] [기간·메모 고치기] [급여 조건] (+ [이 배정 변경 기록] 은 onHistory 가 있을 때)
//   맨 아래 "잘못 등록한 배정 지우기" — 실제로 일이 끝났으면 '배정 끝내기'를 쓰도록 안내.
//   확정된 달 잠금은 서버가 막는다(종전과 같음). 여기서는 잠긴 날짜를 미리 알려 주기만 한다.
import React from 'react';
import Modal from '../../../components/Modal';
import { stdOutlineBtn } from '../adminlayout/designStandard';
import { fmtDate } from './assignmentStatus';
import { periodText, ruleText, shortMd, statusText, statusTone } from './assignmentText';
import { SH } from './assignmentSheet.styles';

function Line({ label, children }) {
  return (
    <div style={SH.line}>
      <span style={SH.lineKey}>{label}</span>
      <span style={SH.lineVal}>{children}</span>
    </div>
  );
}

function ActionButton({ title, sub, onClick, disabled }) {
  return (
    <button type="button" style={{ ...SH.actionBtn, opacity: disabled ? 0.5 : 1 }} onClick={onClick} disabled={disabled}>
      <span>{title}</span>
      {sub && <span style={SH.actionSub}>{sub}</span>}
    </button>
  );
}

export function AssignmentDetailSheet({
  row,
  today,
  saving,
  onClose,
  onMove,
  onEnd,
  onEdit,
  onRules,
  onDelete,
  onHistory = null,
}) {
  if (!row) return null;
  const tone = statusTone(row, today);
  const ended = tone === 'ended';
  const locked = fmtDate(row.condition_locked_through);
  const footer = (
    <div style={SH.footer}>
      <button type="button" style={stdOutlineBtn} onClick={onClose}>닫기</button>
    </div>
  );

  return (
    <Modal
      open
      title={`${row.consultant_name || '1:1 직원'} 배정`}
      icon="👤"
      onClose={onClose}
      footer={footer}
      width="min(560px, calc(100vw - 48px))"
      mobileSheet
      mobileSheetDragClose
    >
      <div style={SH.wrap}>
        <div style={SH.summary}>
          <div style={SH.nameRow}>
            <span style={SH.name}>{row.consultant_name || '-'}</span>
            <span style={SH.badge(tone)}>{statusText(row, today)}</span>
          </div>
          <Line label="담당 마케터">{row.marketer_name || '-'}</Line>
          <Line label="기간">{periodText(row)}</Line>
          <Line label="급여 조건">{ruleText(row)}</Line>
          {row.notes && <Line label="메모">{row.notes}</Line>}
        </div>

        {locked && !ended && (
          <div style={SH.lockHint}>
            {shortMd(locked)}까지는 1:1급여가 확정된 달이라, 담당 바꾸기·끝내기는 그 다음 날부터로만 할 수 있어요.
          </div>
        )}

        <div style={SH.actions}>
          {!ended && (
            <ActionButton
              title="담당 마케터 바꾸기"
              sub="정한 날 전날까지는 지금 마케터, 그날부터 새 마케터"
              onClick={() => onMove(row)}
              disabled={saving}
            />
          )}
          {!ended && (
            <ActionButton
              title="배정 끝내기"
              sub="마지막 근무일까지만 1:1급여에 넣어요. 기록은 남아요"
              onClick={() => onEnd(row)}
              disabled={saving}
            />
          )}
          <ActionButton title="기간·메모 고치기" sub="시작일·끝나는 날·메모" onClick={() => onEdit(row)} disabled={saving} />
          <ActionButton title="급여 조건" sub="월급·인센티브·연차 조건과 바뀐 기록" onClick={() => onRules(row)} disabled={saving} />
          {onHistory && (
            <ActionButton title="이 배정 변경 기록" sub="누가 언제 무엇을 바꿨는지" onClick={() => onHistory(row)} disabled={saving} />
          )}
        </div>

        <div>
          <button type="button" style={SH.dangerBtn} onClick={() => onDelete(row)} disabled={saving}>
            잘못 등록한 배정 지우기
          </button>
          <div style={SH.hint}>기록까지 지워집니다. 실제로 일이 끝났다면 '배정 끝내기'를 써 주세요.</div>
        </div>
      </div>
    </Modal>
  );
}
